export default __webpack_public_path__ + "static/media/otestuj-svoje-zmysly.6cd5562f.svg";